<template>
  <div>
    <div v-if="!sended" v-loading="loading">
      <h2>{{ $t("recover-password.title") }}</h2>
      <p>{{ $t("recover-password.write-your-new-password") }}</p>
      <div class="tags">
        <el-tag class="tag" size="small" :type="passwordRules.minCharacters ? 'success' : 'info'" >{{ $t("configuration.users.ten-character-minimum") }}</el-tag>
        <el-tag class="tag" size="small" :type="passwordRules.atLeastOneMinus ? 'success' : 'info'" >{{ $t("configuration.users.at-least-one-lowercase-letter-(a-z)") }}</el-tag>
        <el-tag class="tag" size="small" :type="passwordRules.atLeastOneMayus ? 'success' : 'info'" >{{ $t("configuration.users.at-least-one-capital-letter-(A-Z)") }}</el-tag>
        <el-tag class="tag" size="small" :type="passwordRules.atLeastOneNumber ? 'success' : 'info'" >{{ $t("configuration.users.at-least-one-number-(0-9)") }}</el-tag>
        <el-tag class="tag" size="small" :type="passwordRules.atLeastOneChar ? 'success' : 'info'" >{{ $t("configuration.users.at-least-one-special-character-(%-#-$-&-*!?-¡¿)") }}</el-tag>
      </div>
      <el-form :model="form" size="medium" :rules="rules">
        <el-form-item :label="$t('configuration.users.password')" prop="password" required>
          <el-input show-password v-model="form.password" type="password" @keyup.native="verifyPassword"></el-input>
        </el-form-item>
        <el-form-item :label="$t('configuration.users.repeat-password')" required prop="repeatPassword">
          <el-input show-password v-model="form.repeatPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item class="mb-0">
          <el-button type="primary" class="button" :disabled="!isButtonEnabled" @click="changePassword">{{ $t("recover-password.change-password") }}</el-button>
          <router-link class="text-center" :to="{ name : 'Login' }">{{ $t("login.go-back-to-login")  }}</router-link>
        </el-form-item>
      </el-form>
    </div>
    <div v-else>
      <div v-if="success">
        <Success class="svg mb-2"></Success>
        <h2 class="text-center">{{ $t("recover-password.your-password-was-updated-successfully") }}</h2>
        <router-link class="text-center" :to="{ name : 'Login' }">{{ $t("login.go-back-to-login")  }}</router-link>
      </div>
      <div v-else>
        <ErrorSvg class="svg"></ErrorSvg>
        <h2 class="text-center">{{ $t("recover-password.there-was-a-problem-trying-to-change-your-password") }}</h2>
        <p class="text-center">{{ $t('common.click') }} <a href="#" @click="sended = false">{{ $t("common.here") }}</a> {{ $t("recover-password.to-try-again") }}</p>
        <p class="text-center">{{ $t('common.click') }} <router-link :to="{ name : 'Login' }">{{ $t("common.here") }}</router-link> {{ $t("recover-password.to-return-to-the-login-screen") }}</p>
        <router-link class="text-center" :to="{ name : 'Login' }">{{ $t("login.go-back-to-login")  }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '@/api/auth'
import ErrorSvg from '@/components/icons/Error'
import Success from '@/components/icons/Success'
export default {
  data() {
    const checkPassword = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('Please input valid username'));
      }

      setTimeout(() => {
        if ( this.passwordRules.atLeastOneMinus && this.passwordRules.atLeastOneMayus && this.passwordRules.atLeastOneNumber && this.passwordRules.atLeastOneChar && this.passwordRules.minCharacters) {
          return callback();
        }
        return callback(new Error());
      }, 1000)
    }

    const checkSamePassword = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('Please input valid username'));
      }

      setTimeout(() => {
        if (this.form.password && this.form.repeatPassword) {
          return callback(new Error());
        }
        return callback();
      }, 1000)
      
    }

    return {
      form : {
        password : '',
        repeatPassword : ''
      },
      loading : false,
      sended : false,
      success : true,
      passwordRules: {
        minCharacters: false,
        atLeastOneMayus: false,
        atLeastOneMinus: false,
        atLeastOneNumber: false,
        atLeastOneChar: false,
      },
      rules: {
        password: [
          { required: true, message: this.$t("configuration.users.the-password-is-required")},
          { validator: checkPassword, message: this.$t("configuration.users.verify-the-password-requirements"), trigger: "blur",},
        ],
        repeatPassword: [
          { required: true, message: this.$t("configuration.users.the-password-is-required")},
          { validator: checkSamePassword, message: this.$t("configuration.users.the-password-are-not-the-same"), trigger: "blur",},
        ]
      }
    }
  },
  methods : {
    verifyPassword() {
      const value = this.form.password;
      this.passwordRules.atLeastOneMinus = /[a-z]/.test(value);
      this.passwordRules.atLeastOneMayus = /[A-Z]/.test(value);
      this.passwordRules.minCharacters = value.length >= 10;
      this.passwordRules.atLeastOneNumber = /[0-9]/.test(value);
      this.passwordRules.atLeastOneChar = /[%$&#\\/*!?¡¿]/.test(value);
    },
    changePassword() {
      this.loading = true
      auth.recoverPassword(this.$route.params.token, this.form)
      .then(() => {
        this.success = true
      }).finally(() => {
        this.loading = false
        this.sended = true;
      })
    }
  },
  components : {
    Success,
    ErrorSvg
  },
  computed : {
    isButtonEnabled() {
      return this.passwordRules.atLeastOneMinus
        && this.passwordRules.atLeastOneMayus
        && this.passwordRules.minCharacters
        && this.passwordRules.atLeastOneNumber
        && this.passwordRules.atLeastOneChar
        && this.form.password === this.form.repeatPassword
    }
  }
}
</script>

<style scoped>

.svg {
  margin: 0 auto
}

.tags {
  display: flex;
  flex-direction: row;
  gap: calc(var(--column) / 2);
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: var(--column);
}

.button {
  width: 100%;
}

.text-center {
  display: block;
  width: 100%;
}
</style>